;(function($, undefined){
    'use strict';

    var rnn = window.rnn;

    function shrinkInternal($el){
        var $parent = $el.parent();

        if($parent.hasClass('surface_level')){
            var $openChild = $el.children('div.third_level.open');
            if($openChild.length > 0){
                // there is a child open. close it.
                addExpand($openChild.prev());
                slideUp($openChild);
            }
        }
    }

    function slideUp($el){

        shrinkInternal($el);

        $el.slideUp({queue: false});
        $el.removeClass('open').addClass('closed');
    }

    function addShrink($el){
        $el.removeClass('expandIcon').addClass('shrinkIcon');
        var $arrow = $el.children('.icon16x16-arrow-icon-dropdown');
        $arrow.removeClass('icon16x16-arrow-icon-dropdown').addClass('icon16x16-arrow-icon-slideup');
    }

    function addExpand($el){
        $el.removeClass('shrinkIcon').addClass('expandIcon');
        var $arrow = $el.children('.icon16x16-arrow-icon-slideup');
        $arrow.removeClass('icon16x16-arrow-icon-slideup').addClass('icon16x16-arrow-icon-dropdown');
    }


    function shrinkExisting($el){
        // checks if any other items are open and shrinks them
        // before opening the new section.

        var $parent = $el.parent();

        // closing the bottom level items
        if($parent.hasClass('second_level')){
            var $openSib = $el.siblings('div.third_level.open');
            if($openSib.length > 0){
                // there is a sibling open. close it.
                addExpand($openSib.prev());
                slideUp($openSib);
            }
        }

        if($parent.hasClass('surface_level')){

            $('.third_level.open').each(function() {
                addExpand($(this).prev());
                slideUp($(this));
            });

            $('.second_level.open').each(function() {
                addExpand($(this).prev());
                slideUp($(this));
            });
        }
    }

    function slideDown($el){

        shrinkExisting($el);

        $el.slideDown({queue: false});
        $el.removeClass('closed').addClass('open');
    }

    function generateAccordian(){
        $('.accordian_item .surface_level li').click(function(){

            var $nextEl = $(this).next('.second_level');

            if($nextEl.hasClass('closed')){
                addShrink($(this));
                slideDown($nextEl);
            }else{
                addExpand($(this));
                slideUp($nextEl);
            }
        });

        $('.accordian_item .second_level li').click(function(){

            var $nextEl = $(this).next('.third_level');

            if($nextEl.hasClass('closed')){
                addShrink($(this));
                slideDown($nextEl);
            }else{
                addExpand($(this));
                slideUp($nextEl);
            }
        });
    }

    function postClassifiedsAds(){
        generateAccordian();
    }

    rnn.modules.register('postClassifiedsAds', {
        init: postClassifiedsAds
    });

})(jQuery);

